import React, { useEffect, useState,useRef } from "react";
import "./grid-container.css";
import SectionHeader from "../sectionHeader/sectionHeader";
import Anchor from "../Link/anchor";
import { getAWSUrl } from "../api/core";
import LazyImg from "../lazy/lazy";
import { formatDate } from "../javascript/function";
import { BORDER } from "../../global";


const HighlightTextGrid = (props) => {
  const mounted = useRef(false);
//   const init = { playlist: [] };
  const [elem, setElem] = useState([]);
  const [felemItem, setFItem] = useState([]);
  const [selemItem, setSItem] = useState([]);
  const [telemItem, setTItem] = useState([]);
  const [faelemItem, setFAItem] = useState([]);
  const [saelemItem, setSAItem] = useState([]);
  const [taelemItem, setTAItem] = useState([]);
  const [loading, isLoading] = useState(true);
  const [error, SetError] = useState(false);
  const [elemdisplay, setElemDisplay] = useState(true);
//   const history = useHistory();


  useEffect(() => {
    mounted.current = true;
    const ElemDetail = async () => {
      if (mounted.current) {
        setElem(props.information);

      
        setElemDisplay(props.information.devices[0].itemVisibility);
        setFItem(props.information.items);
        let arr = props.information.items;
        let farr = arr.filter(function (el)
        {
          return el.itemType==="First Section" && el.itemid.devices[0].itemVisibility
                 
        }
        );
        setFAItem(farr[0]);
        let sarr = arr.filter(function (el)
        {
          return el.itemType==="Second Section" && el.itemid.devices[0].itemVisibility
                 
        }
        );
        setSAItem(sarr[0]);
        let tarr = arr.filter(function (el)
        {
          return el.itemType==="Third Section" && el.itemid.devices[0].itemVisibility
                 
        }
        );
        setTAItem(tarr[0]);
        setFItem(farr);
        setSItem(sarr);
        setTItem(tarr);
        isLoading(false);
        SetError(false);

      }
    };

 
   
      ElemDetail();
  
    

    return () => {
      mounted.current = false;
    };
  }, [props.information]);

  if (
    elemdisplay &&
    !error &&
    !loading &&
    props.information !== null &&
    props.information !== undefined
  )
  {
    return (
        <section className="new-news-area bg-color-none grid">
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12 col-md-4">
                <div className="clearfix"></div>
                <SectionHeader
                  title={elem.tab1Name}
                  linkTitle={""}
                  link={""}
                  header={true}
                  news={true}
                ></SectionHeader>
    
                <div className="clearfix"></div>
                <div className="new-news-list">
                <div className={BORDER?"single-new-news":"single-new-news no-border"}>
                    <LazyImg  src={faelemItem.itemid.bannerImage?getAWSUrl()+faelemItem.itemid.bannerImage.imagekey:""}
                    alt="post-img" orient={"landscape"} className={BORDER?"":"no-border"}></LazyImg>
                 
                  <div className={elem.displayNameVisibility === "On Hover" || elem.displayNameVisibility === "Show Header Only"?"news-content":elem.displayNameVisibility === "Show Always"?"news-content viewHeader":"news-content viewNone"}>
                    <ul>
                      <li className="caldate">
                        <i className="icofont-calendar" /> {formatDate(faelemItem.itemid.date)}
                      </li>
                    </ul>
                    <h3>
                      <a href="#!">{faelemItem.itemid.mainHeader?faelemItem.itemid.mainHeader:faelemItem.itemid.displayName}</a>
                    </h3>
                  </div>
                  <div className="tags bg-3">
                    <a href="#!">{faelemItem.itemid.tag}</a>
                  </div>
                </div>
              </div>
              <div className="clearfix"></div>
                <ul className="list-space-xs list-square-bullet-exclude-first list-seperated list-unstyled">
                {felemItem !== null
                ? felemItem.map((item, index) => (
                    item.itemid.devices[0].itemVisibility && index>0  ?
                    <li key={index}>
                    {" "}
                    <article className="post post--horizontal ">
                      <div className="post__text ">
                        <h3 className="post__title typescale-0">
                          <Anchor to={
                              item.itemid.pageType === "externalPage"
                                ? item.itemid.externalPage
                                : item.itemid.pageType === "internalPage"
                                ? item.itemid.internalPage
                                : item.itemid.pageType === "videoPage"
                                ? "/" +
                                  props.match.params.AppId +
                                  "/" +
                                  item.itemid.pageType +
                                  "/" +
                                  item.itemid.videoId
                                : item.itemid.urlName !== ""
                                ? "/" +
                                  props.match.params.AppId +
                                  "/" +
                                  item.itemid.urlName
                                : item.itemid.pageType + "/" + item.itemid._id
                            }
                            className={"lighter"}>
                          {item.itemid.mainHeader?item.itemid.mainHeader:item.itemid.displayName?item.itemid.displayName:item.itemid.description}
                          </Anchor>
                        </h3>
                      </div>
                    </article>
                  </li>
                  :""
    
                ))
                :""}
         
                </ul>
              </div>
              <div className="col-sm-12 col-md-4 text-padding">
                <div className="clearfix"></div>
                <SectionHeader
                  title={elem.tab2Name}
                  linkTitle={""}
                  link={""}
                  header={true}
                  news={true}
                ></SectionHeader>
    
                <div className="clearfix"></div>
                <div className="new-news-list">
                <div className={BORDER?"single-new-news":"single-new-news no-border"}>
                    <LazyImg  src={saelemItem.itemid.bannerImage?getAWSUrl()+saelemItem.itemid.bannerImage.imagekey:""}
                    alt="post-img" orient={"landscape"} className={BORDER?"":"no-border"}></LazyImg>
                 
                  <div className={elem.displayNameVisibility === "On Hover" || elem.displayNameVisibility === "Show Header Only"?"news-content":elem.displayNameVisibility === "Show Always"?"news-content viewHeader":"news-content viewNone"}>
                    <ul>
                      <li className="caldate">
                        <i className="icofont-calendar" /> {formatDate(saelemItem.itemid.date)}
                      </li>
                    </ul>
                    <h3>
                      <a href="#!">{saelemItem.itemid.mainHeader?saelemItem.itemid.mainHeader:saelemItem.itemid.displayName}</a>
                    </h3>
                  </div>
                  <div className="tags bg-3">
                    <a href="#!">{saelemItem.itemid.tag}</a>
                  </div>
                </div>
              </div>
              <div className="clearfix"></div>
                <ul className="list-space-xs list-square-bullet-exclude-first list-seperated list-unstyled">
                {selemItem !== null
                ? selemItem.map((item, index) => (
    
                    item.itemid.devices[0].itemVisibility && index>0  ?
                    <li key={index}>
                    {" "}
                    <article className="post post--horizontal ">
                      <div className="post__text ">
                        <h3 className="post__title typescale-0">
                          <Anchor to={
                              item.itemid.pageType === "externalPage"
                                ? item.itemid.externalPage
                                : item.itemid.pageType === "internalPage"
                                ? item.itemid.internalPage
                                : item.itemid.pageType === "videoPage"
                                ? "/" +
                                  props.match.params.AppId +
                                  "/" +
                                  item.itemid.pageType +
                                  "/" +
                                  item.itemid.videoId
                                : item.itemid.urlName !== ""
                                ? "/" +
                                  props.match.params.AppId +
                                  "/" +
                                  item.itemid.urlName
                                : item.itemid.pageType + "/" + item.itemid._id
                            }
                            className={"lighter"}>
                          {item.itemid.mainHeader?item.itemid.mainHeader:item.itemid.displayName?item.itemid.displayName:item.itemid.description}
                          </Anchor>
                        </h3>
                      </div>
                    </article>
                  </li>
                  :""
    
                ))
                :""}
                </ul>
              </div>
              <div className="col-sm-12 col-md-4 text-padding">
                <div className="clearfix"></div>
                <SectionHeader
                  title={elem.tab3Name}
                  linkTitle={""}
                  link={""}
                  header={true}
                  news={true}
                ></SectionHeader>
    
                <div className="clearfix"></div>
                <div className="new-news-list">
                <div className={BORDER?"single-new-news":"single-new-news no-border"}>
                    <LazyImg  src={taelemItem.itemid.bannerImage?getAWSUrl()+taelemItem.itemid.bannerImage.imagekey:""}
                    alt="post-img" orient={"landscape"} className={BORDER?"":"no-border"}></LazyImg>
                 
                  <div className={elem.displayNameVisibility === "On Hover" || elem.displayNameVisibility === "Show Header Only"?"news-content":elem.displayNameVisibility === "Show Always"?"news-content viewHeader":"news-content viewNone"}>
                    <ul>
                      <li className="caldate">
                        <i className="icofont-calendar" /> {formatDate(taelemItem.itemid.date)}
                      </li>
                    </ul>
                    <h3>
                      <a href="#!">{taelemItem.itemid.mainHeader?taelemItem.itemid.mainHeader:taelemItem.itemid.displayName}</a>
                    </h3>
                  </div>
                  <div className="tags bg-3">
                    <a href="#!">{taelemItem.itemid.tag}</a>
                  </div>
                </div>
              </div>
              <div className="clearfix"></div>
                <ul className="list-space-xs list-square-bullet-exclude-first list-seperated list-unstyled">
                {telemItem !== null
                ? telemItem.map((item, index) => (
                    item.itemid.devices[0].itemVisibility && index>0 ?
                    <li key={index}>
                    {" "}
                    <article className="post post--horizontal ">

                        
                      <div className="post__text ">
                        <h3 className="post__title typescale-0">
                          <Anchor to={
                              item.itemid.pageType === "externalPage"
                                ? item.itemid.externalPage
                                : item.itemid.pageType === "internalPage"
                                ? item.itemid.internalPage
                                : item.itemid.pageType === "videoPage"
                                ? "/" +
                                  props.match.params.AppId +
                                  "/" +
                                  item.itemid.pageType +
                                  "/" +
                                  item.itemid.videoId
                                : item.itemid.urlName !== ""
                                ? "/" +
                                  props.match.params.AppId +
                                  "/" +
                                  item.itemid.urlName
                                : item.itemid.pageType + "/" + item.itemid._id
                            }
                            className={"lighter"}>
                          {item.itemid.mainHeader?item.itemid.mainHeader:item.itemid.displayName?item.itemid.displayName:item.itemid.description}
                          </Anchor>
                        </h3>
                      </div>
                    </article>
                  </li>
                  :""
    
                ))
                :""}
                </ul>
              </div>
            </div>
          </div>
        </section>
      );
  }
  else if (elemdisplay && !error && loading) {
    return <div style={{ minHeight: "400px" }}></div>;
  } else {
    return <div></div>;
  }

};

export default HighlightTextGrid;
